import gql from "graphql-tag";
import { ChecklistDocumentFormData } from "../ChecklistDocumentFormData";

export interface update_checklist_document_variables {
    id: number;
    url: string;
}

export interface update_checklist_document_response {
    update_qat_checklist_document_one: {
        id: string
    }
}
export interface add_checklist_document_variables {  
        object: ChecklistDocumentFormData,
}

export interface add_checklist_document_response {
    add_qat_checklist_document_one: {
        id:string
    }
}


export const ADD_CHECKLIST_DOCUMENT = gql`
  mutation insert_qat_checklist_document_one(
    $object: qat_checklist_document_insert_input!
  ) {
    insert_qat_checklist_document_one(
      object: $object
    ) {
        id
    }
  }
`;

  export const UPDATE_CHECKLIST_DOCUMENT = gql`
  mutation update_qat_checklist_document(
      $id: Int!
      $url: String!
  ){
    update_qat_checklist_document(where: {building_id: {_eq: $id}}, _set: {url: $url}) {
        affected_rows
      }

  }
`
